/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Awss3Config,
  Awss3Config$inboundSchema,
  Awss3Config$Outbound,
  Awss3Config$outboundSchema,
} from "./awss3config.js";
import {
  Awss3Credentials,
  Awss3Credentials$inboundSchema,
  Awss3Credentials$Outbound,
  Awss3Credentials$outboundSchema,
} from "./awss3credentials.js";
import {
  Topics,
  Topics$inboundSchema,
  Topics$Outbound,
  Topics$outboundSchema,
} from "./topics.js";

export type DestinationUpdateAwss3 = {
  /**
   * "*" or an array of enabled topics.
   */
  topics?: Topics | undefined;
  /**
   * Optional JSON schema filter for event matching. Events must match this filter to be delivered to this destination.
   *
   * @remarks
   * Supports operators: $eq, $neq, $gt, $gte, $lt, $lte, $in, $nin, $startsWith, $endsWith, $exist, $or, $and, $not.
   * If null or empty, all events matching the topic filter will be delivered.
   * To remove an existing filter when updating a destination, set filter to an empty object `{}`.
   */
  filter?: { [k: string]: any } | null | undefined;
  config?: Awss3Config | undefined;
  credentials?: Awss3Credentials | undefined;
  /**
   * Static key-value pairs merged into event metadata on every attempt.
   */
  deliveryMetadata?: { [k: string]: string } | null | undefined;
  /**
   * Arbitrary contextual information stored with the destination.
   */
  metadata?: { [k: string]: string } | null | undefined;
};

/** @internal */
export const DestinationUpdateAwss3$inboundSchema: z.ZodType<
  DestinationUpdateAwss3,
  z.ZodTypeDef,
  unknown
> = z.object({
  topics: Topics$inboundSchema.optional(),
  filter: z.nullable(z.record(z.any())).optional(),
  config: Awss3Config$inboundSchema.optional(),
  credentials: Awss3Credentials$inboundSchema.optional(),
  delivery_metadata: z.nullable(z.record(z.string())).optional(),
  metadata: z.nullable(z.record(z.string())).optional(),
}).transform((v) => {
  return remap$(v, {
    "delivery_metadata": "deliveryMetadata",
  });
});
/** @internal */
export type DestinationUpdateAwss3$Outbound = {
  topics?: Topics$Outbound | undefined;
  filter?: { [k: string]: any } | null | undefined;
  config?: Awss3Config$Outbound | undefined;
  credentials?: Awss3Credentials$Outbound | undefined;
  delivery_metadata?: { [k: string]: string } | null | undefined;
  metadata?: { [k: string]: string } | null | undefined;
};

/** @internal */
export const DestinationUpdateAwss3$outboundSchema: z.ZodType<
  DestinationUpdateAwss3$Outbound,
  z.ZodTypeDef,
  DestinationUpdateAwss3
> = z.object({
  topics: Topics$outboundSchema.optional(),
  filter: z.nullable(z.record(z.any())).optional(),
  config: Awss3Config$outboundSchema.optional(),
  credentials: Awss3Credentials$outboundSchema.optional(),
  deliveryMetadata: z.nullable(z.record(z.string())).optional(),
  metadata: z.nullable(z.record(z.string())).optional(),
}).transform((v) => {
  return remap$(v, {
    deliveryMetadata: "delivery_metadata",
  });
});

export function destinationUpdateAwss3ToJSON(
  destinationUpdateAwss3: DestinationUpdateAwss3,
): string {
  return JSON.stringify(
    DestinationUpdateAwss3$outboundSchema.parse(destinationUpdateAwss3),
  );
}
export function destinationUpdateAwss3FromJSON(
  jsonString: string,
): SafeParseResult<DestinationUpdateAwss3, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DestinationUpdateAwss3$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DestinationUpdateAwss3' from JSON`,
  );
}
